import { Root, TBody, THead, Td, Th, Tr, Wrapper } from './styles';

export default {
  Wrapper,
  Root,
  TBody,
  THead,
  Td,
  Th,
  Tr,
};
